import KNAttribute from 'components/KNAttribute/KNAttribute'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { LegData, UitReference } from './TripDetails.types'
import i18n from 'i18n'

export interface UitReferenceAttributeProps {
  leg: LegData
}

const getValue = (uitReference?: UitReference) => {
  if (!uitReference) {
    return undefined
  }
  return uitReference.isRequired ? uitReference.code : i18n.t('screens.cs.trip_details.card.uit_not_required')
}

const UitReferenceAttribute = ({
  leg,
}: UitReferenceAttributeProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <KNAttribute
      label={t('screens.cs.trip_details.card.uit_reference')}
      value={getValue(leg.attributes.uitReference)}
      size="medium"
      hideEmpty
    />
  )
}

export default UitReferenceAttribute
